import React, { Component } from "react";
import BreadCrumbOwn from "./BreadCrumbOwn";
import { Grid, Container } from "@material-ui/core";
import { PostData } from "../../api/service";


export default class CommonTextPattern extends Component {
  state = {
    data: "",
    isLoaded: false,
  };

  componentDidMount() {
    let d = {
      dept_code: "NSS",
      type: this.props.type,
    };

    PostData(`/getnoticesbytypedept`, d).then((resp) => {
      if (resp.length > 0) {
        this.setState({
          data: resp[0],
          isLoaded: true,
        });
      }
    });
  }
  render() {
    const { data, isLoaded } = this.state;

    // collect images from featured_photo + upload_info
    let images = [];
    if (isLoaded && data) {
      if (Array.isArray(data.featured_photo)) {
        images = images.concat(data.featured_photo.filter((f) => f && f.fileType === "image"));
      }
      if (Array.isArray(data.upload_info)) {
        images = images.concat(data.upload_info.filter((f) => f && f.fileType === "image"));
      }
    }
    const files =
      isLoaded && data && Array.isArray(data.upload_info)
        ? data.upload_info.filter((f) => f && f.fileType !== "image")
        : [];

    const hasImages = images.length > 0;
    const showProfile = this.props.showProfile === true;
    // name + designation are stored in title + posted_as for profile pages
    const name = showProfile && data ? data.title : "";
    const designation = showProfile && data ? data.posted_as : "";
    const showLeft = hasImages || (showProfile && (name || designation));

    return (
      <div>
        <BreadCrumbOwn title={this.props.title} />
        <Container style={{ minHeight: "600px" }} className="mb-5">
          <br></br>
          {isLoaded && data && (
            <Grid container spacing={4}>
              {showLeft && (
                <Grid item xs={12} md={4}>
                  {images.map((img, i) => (
                    <img
                      key={i}
                      src={img.url}
                      alt={this.props.title}
                      style={{
                        width: "100%",
                        borderRadius: 10,
                        marginBottom: 12,
                        boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
                        objectFit: "cover",
                      }}
                    />
                  ))}

                  {showProfile && (name || designation) && (
                    <div style={{ textAlign: "center", marginTop: 4 }}>
                      {name && (
                        <div style={{ fontWeight: 700, fontSize: 18, color: "#0B3D2E" }}>
                          {name}
                        </div>
                      )}
                      {designation && (
                        <div style={{ fontSize: 14, color: "#566573", marginTop: 2 }}>
                          {designation}
                        </div>
                      )}
                    </div>
                  )}
                </Grid>
              )}

              <Grid item xs={12} md={showLeft ? 8 : 12}>
                <div
                  className="prose"
                  dangerouslySetInnerHTML={{ __html: data.description }}
                ></div>

                {files.length > 0 && (
                  <div style={{ marginTop: 20 }}>
                    {files.map((f, i) => (
                      <a
                        key={i}
                        href={f.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ display: "block", color: "#2054CD", marginBottom: 6 }}
                      >
                        {f.path}
                      </a>
                    ))}
                  </div>
                )}
              </Grid>
            </Grid>
          )}
        </Container>
      </div>
    );
  }
}
